{
	"productImage": "Product photo",
	"select": "Select a photo",
	"setTagInput": "search for the product using keywords",
	"notInformed": "Name not informed",
	"searchMoreOptions": "Browse more database options",
	"selectFrom": "Select from ",
	"computer": "computer"
}
